import styled from '@emotion/styled';
import { type CarouselProps } from '@silvertours/front-entities';

const Container = styled.div<CarouselProps>`
  display: flex;
  gap: ${({ theme }) => theme.spacing[20]};
  padding-left: 1rem;
  padding-right: 1rem;

  & > * {
    width: 326px;
  }

  ${({ theme }) => theme.mq('sm')} {
    gap: ${({ theme }) => theme.spacing[40]};

    & > * {
      width: 392px;
    }

    padding-left: 2rem;
    padding-right: 2rem;
  }

  ${({ theme }) => theme.mq('xl')} {
    gap: ${({ theme }) => theme.spacing[50]};
    padding-left: clamp(2rem, calc((100vw - 1220px) / 2), 22rem);
    padding-right: clamp(2rem, calc((100vw - 1220px) / 2), 22rem);
  }

  ${({ theme }) => theme.mq('xxl')} {
    padding-left: clamp(2rem, 350px, 22rem);
    padding-right: clamp(2rem, 350px, 22rem);
  }
`;

const Wrapper = styled.div`
  display: block;
  position: relative;
  color: ${({ theme }) => theme.colors.neutral.grey160};
  background-color: ${({ theme }) => theme.colors.neutral.grey20};

  ${({ theme }) => theme.mq('md')} {
    padding-bottom: 2rem;
  }

  nav {
    padding-right: ${({ theme }) => theme.spacing[40]};

    ${({ theme }) => theme.mq('sm')} {
      padding-right: 2rem;
    }

    ${({ theme }) => theme.mq('xl')} {
      padding-right: clamp(2rem, calc((100vw - 1220px) / 2), 22rem);
    }

    ${({ theme }) => theme.mq('xxl')} {
      padding-right: clamp(2rem, 350px, 22rem);
    }
  }
`;

export { Container, Wrapper };
